/**
 * @generated SignedSource<<9688a2eba3a278b9b0e9195b2701c738>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type AccountServiceLevel =
  | 'RH_GOLD'
  | 'RH_GOLD_BASIC'
  | 'RH_PLATINUM'
  | 'RH_SILVER'
  | 'RH_SOLID_GOLD'
  | 'UNKNOWN'
  | 'X_1'
  | 'X_1_PLUS'
  | '%future added value';
export type CreateCreditApplicationError =
  | 'ACCESS_DENIED'
  | 'AGE_RESTRICTED_STATE'
  | 'APPLICATION_COLLISION'
  | 'AUTHORIZED_USER_CONFLICT'
  | 'INVALID_ADDRESS'
  | 'JOIN_WAITLIST'
  | 'ON_WAITLIST'
  | 'PRIMARY_CONFLICT'
  | 'REAPPLY_COOLDOWN'
  | 'RESTRICTED_STATE'
  | 'UNKNOWN'
  | '%future added value';
export type CreateCreditApplicationRequest = {
  address: CreateCreditApplicationAddress;
  attribution?: CreateCreditApplicationAttributionContext | null;
  closeAuthorizedUserOverride: boolean;
  dateOfBirth: string;
  e164: string;
  email: string;
  firstName: string;
  forceAddressOverride: boolean;
  incomeMicro: number;
  lastName: string;
  monthlyHousingCostMicro?: number | null;
  serviceLevel: AccountServiceLevel;
  ssn: string;
};
export type CreateCreditApplicationAddress = {
  locality: string;
  primaryAddressLine: string;
  secondaryAddressLine?: string | null;
  subdivision: string;
  zip5: string;
};
export type CreateCreditApplicationAttributionContext = {
  creditKarmaCampaign?: string | null;
  creditKarmaLightboxBadge?: string | null;
  creditKarmaOfferVariant?: string | null;
  creditKarmaTrackingId?: string | null;
  creditKarmaTrackingPayload?: string | null;
  inviteKey?: string | null;
  utmParams?: UtmParamsInput | null;
  x1InviteSlug?: string | null;
};
export type UtmParamsInput = {
  campaign?: string | null;
  content?: string | null;
  medium?: string | null;
  source: string;
  term?: string | null;
};
export type TermsAndConditionsPageCreateCreditApplicationMutation$variables = {
  q: CreateCreditApplicationRequest;
};
export type TermsAndConditionsPageCreateCreditApplicationMutation$data = {
  readonly createCreditApplication: {
    readonly data: {
      readonly creditApplication: {
        readonly id: string;
      };
    } | null;
    readonly errors: ReadonlyArray<CreateCreditApplicationError>;
  };
};
export type TermsAndConditionsPageCreateCreditApplicationMutation = {
  response: TermsAndConditionsPageCreateCreditApplicationMutation$data;
  variables: TermsAndConditionsPageCreateCreditApplicationMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'q',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'q',
            variableName: 'q',
          },
        ],
        concreteType: 'CreateCreditApplicationValidation',
        kind: 'LinkedField',
        name: 'createCreditApplication',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'CreateCreditApplicationResponse',
            kind: 'LinkedField',
            name: 'data',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                concreteType: 'CreditApplication',
                kind: 'LinkedField',
                name: 'creditApplication',
                plural: false,
                selections: [
                  {
                    alias: null,
                    args: null,
                    kind: 'ScalarField',
                    name: 'id',
                    storageKey: null,
                  },
                ],
                storageKey: null,
              },
            ],
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'errors',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'TermsAndConditionsPageCreateCreditApplicationMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'TermsAndConditionsPageCreateCreditApplicationMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '241fa9cf45baf5250b4a60c2f6ce94df',
      id: null,
      metadata: {},
      name: 'TermsAndConditionsPageCreateCreditApplicationMutation',
      operationKind: 'mutation',
      text: 'mutation TermsAndConditionsPageCreateCreditApplicationMutation(\n  $q: CreateCreditApplicationRequest!\n) {\n  createCreditApplication(q: $q) {\n    data {\n      creditApplication {\n        id\n      }\n    }\n    errors\n  }\n}\n',
    },
  };
})();

(node as any).hash = '05dc73478d443afa7a359674ccd7c9fe';

export default node;
